import { Box, Center, Container, Divider, Flex, FlexProps, Text } from '@chakra-ui/react';
import { useScreenType } from '../../Shared/Hooks/useScreenType';
import { Logo } from '../Logo';
import SocialMediaLink from '../SocialMediaLink';

const Footer = () => {
    const screenInfo = useScreenType();
    const isMobile = screenInfo?.screenSize === 'extrasmall';

    let flexProps: FlexProps = {
        flexDirection: 'row'
    };

    if (isMobile) {
        flexProps.flexDirection = 'column';
    };

    return (
        <Container
            bg='brand.black'
            color='brand.white'
            display='flex'
            maxWidth='100vw'
            margin='unset'>
                <Center width='100vw' flexDirection='column' marginTop='10px'>
                    <Flex flexWrap='wrap' {...flexProps}>
                            <Logo />
                            {
                                !isMobile &&
                                <Center>
                                    <Divider orientation='vertical' height='100px' margin='10px'/>
                                </Center>
                            }
                            <Flex margin='10px'>
                                <Center>
                                    <Flex flexDirection='column' fontSize='18px'>
                                        <SocialMediaLink platform='LinkedIn' />
                                    </Flex>
                                </Center>
                            </Flex>
                    </Flex>
                    <Flex>
                        <Center padding='10px'>
                            <Text fontSize='xs'>
                                &copy; Virtue Aerospace 2026
                            </Text>
                        </Center>
                    </Flex>
                </Center>
        </Container>
    );
};

export default Footer;